import request from '@/utils/axios.js'

// 核销
export function checkCoupon (data) {
  return request({
    url: '/manageMarket/publicAPI/hq/WriteOff/hq',
    method: 'post',
    data: data
  })
}

// 参加活动
export function getRegister (data) {
  return request({
    url: '/manageMarket/mobileAPI/hq/receive/member',
    method: 'post',
    data: data
  })
}

// 获取微信分享验签签名
export function getWxConfig (data) {
  return request({
    url: '/manageApp/mobileAPI/share/wechat/sign',
    method: 'post',
    data: data
  })
}
